const prefix = 'segments/'

export const ActionTypes = {
  RECEIVE_SEGMENTS: `${prefix}RECEIVE_SEGMENTS`,
  RECEIVE_SEGMENTS_FILTERED: `${prefix}RECEIVE_SEGMENTS_FILTERED`,
  FILTER_SEGMENT_TYPE: `${prefix}FILTER_SEGMENT_TYPE`,
  SELECT_SEGMENT: `${prefix}SELECT_SEGMENT`,
  DESELECT_SEGMENT: `${prefix}DESELECT_SEGMENT`,
}

export const receiveSegments = segments => {
  return {
    type: ActionTypes.RECEIVE_SEGMENTS,
    segments
  }
}

export const receiveSegmentsFiltered = filteredSegments => {
  return {
    type: ActionTypes.FILTER_SEGMENT_TYPE,
    filteredSegments
  }
}

export const filterSegmentType = filterByType => {
  return {
    type: ActionTypes.FILTER_SEGMENT_TYPE,
    filterByType
  }
}

export const selectSegment = selectedId => {
  return {
    type: ActionTypes.SELECT_SEGMENT,
    selectedId
  }
}

export const deselectSegment = deselectedId => {
  return {
    type: ActionTypes.DESELECT_SEGMENT,
    deselectedId
  }
}